import { OptimizelyDecision } from '@optimizely/react-sdk';
import { PlanCode } from '../Domain/IPlanCodes';
import { Price } from '../Domain/IPrice';
import { SubscriptionPlans } from './Data/localizationConnector';
import { SEASONAL_PLAN_CODE, ANNUAL_PLAN_CODE } from './planCodes';

// prettier-ignore
const getPriceForDescription = (number: number) => (number % 100 === 0 ? number / 100 : (number / 100).toFixed(2));

// prettier-ignore
const getPriceWithDecimals = (number: number) => (number / 100).toFixed(2);

// prettier-ignore
const getLowestPrice = (prices: Price[]) => prices.sort((a, b) => (a.price && b.price ? a.price - b.price : 0))[0];

// prettier-ignore
const getPriceByPlanCode = (prices: Price[], planCode: PlanCode) => prices.find((p) => p.planCode === planCode);

const setPricesFromPlans = (plans: SubscriptionPlans): Price[] => {
  const seasonalPlan = plans[SEASONAL_PLAN_CODE];
  const annualPlan = plans[ANNUAL_PLAN_CODE];
  const planPrices = [
    {
      planCode: SEASONAL_PLAN_CODE,
      price: seasonalPlan?.boxPrice?.amount,
      annualPrice: seasonalPlan?.price?.amount,
      save: 0,
    },
    {
      planCode: ANNUAL_PLAN_CODE,
      price: annualPlan?.boxPrice?.amount,
      annualPrice: annualPlan?.price?.amount,
      save: 2000,
    },
  ];
  return planPrices;
};

const getSeasonalPriceWithFeatureFlag = (
  prices: Price[],
  flag: OptimizelyDecision | undefined,
  codePlan: PlanCode,
): Price | undefined => {
  const seasonalPlan = getPriceByPlanCode(prices, codePlan);

  if (flag?.enabled && seasonalPlan) {
    const basePlanPrice = seasonalPlan?.price || 0;
    const increasedAmount = flag.variables?.increasedPrice as number;
    const total = basePlanPrice + increasedAmount;
    const newPlan = {
      ...seasonalPlan,
      price: parseFloat(total.toFixed(2)),
    };

    return newPlan;
  }

  return seasonalPlan;
};

export {
  getPriceForDescription,
  getPriceWithDecimals,
  getLowestPrice,
  getPriceByPlanCode,
  setPricesFromPlans,
  getSeasonalPriceWithFeatureFlag,
};
